interface IArrayUtil {
  reorder: <T>(list: Array<T>, fromIndex: number, destinationIndex: number) => Array<T>

  groupBy: <T, K>(list: Array<T>, groupFn: (element: T) => K) => Map<K, Array<T>>

  chunks: <T>(list: Array<T>, chunkSize: number) => Array<Array<T>>
}

const ArrayUtil: IArrayUtil = {
  reorder: <T>(list: Array<T>, fromIndex: number, destinationIndex: number): Array<T> => {
    const result = Array.from(list)
    const [removed] = result.splice(fromIndex, 1)
    result.splice(destinationIndex, 0, removed)

    return result
  },

  groupBy: <T, K>(list: Array<T>, groupFn: (element: T) => K): Map<K, Array<T>> => {
    return list.reduce((map, element) => {
      const key = groupFn(element)

      return map.set(key, [element].concat(...(map.get(key) || [])))
    }, new Map<K, Array<T>>())
  },

  chunks(list, chunkSize) {
    const chunks = []

    if (chunkSize === 0) return []

    for (let i = 0; i < list.length; i += chunkSize) {
      chunks.push(list.slice(i, i + chunkSize))
    }

    return chunks
  },
}

export default ArrayUtil
